import { Coordinates } from '../subtopic/subtopic.aggregate';

export interface Topic {
  id: number;
  name: string;
  enabled: boolean;
  therapyId: number;
  therapyName: string;

  nameLanguage: string;
  therapyNameLanguage: string;

  panoramicImageUrl?: string;

  position: Coordinates;
}

export interface TopicRepoModel {
  id: number;
  name: string;
  enabled: boolean;
  therapyId: number;
  therapyName: string;

  nameLanguage: string;
  therapyNameLanguage: string;

  panoramicImageUrl?: string;

  positionX: number;
  positionY: number;
}

export function TopicToRepoModel(model: Topic) {
  const value: TopicRepoModel = {
    id: model.id,
    name: model.name,
    enabled: model.enabled,
    therapyId: model.therapyId,
    therapyName: model.therapyName,
    nameLanguage: model.nameLanguage,
    therapyNameLanguage: model.therapyNameLanguage,
    panoramicImageUrl: model.panoramicImageUrl,
    positionX: model.position.x,
    positionY: model.position.y
  };

  return value;
}

export function TopicFromRepoModel(model: TopicRepoModel) {
  const value: Topic = {
    id: model.id,
    name: model.name,
    enabled: model.enabled,
    therapyId: model.therapyId,
    therapyName: model.therapyName,
    nameLanguage: model.nameLanguage,
    therapyNameLanguage: model.therapyNameLanguage,
    panoramicImageUrl: model.panoramicImageUrl,
    position: { x: model.positionX, y: model.positionY }
  };

  return value;
}
